import React from 'react';
import cn from 'clsx';

import styles from './gauge.scss';

interface GaugeProps {
  className?: string;
  value?: string | number;
}

function Gauge(props: GaugeProps) {
  const { className, value } = props;

  return (
    <div className={cn(styles['container'], `gauge ${className || ''}`)}>
      <span
        className={cn(styles['value'], 'gauge__value')}
        data-testid="gauge-value"
      >
        {Number.isInteger(value) ? `${value}.0` : value}
      </span>
      <span
        className={cn(styles['label'], 'gauge__label')}
        data-testid="gauge-label"
      >
        out of 5
      </span>
    </div>
  );
}

export default Gauge;
